import { Button } from "./Button";
import { EyebrowHeading, Section } from "./Section";
import { Reveal } from "./wow/Reveal";
import { Magnetic } from "./wow/MagneticButton";
import { useLocale } from "@/i18n/LocaleProvider";

const pillarsSv = [
  { title: "Trygga löpande leveranser", body: "Varje leverans sitter. Varje gång. Samma kvalitet i månad 12 som i månad 1, med ett team som redan kan ert varumärke utan och innan." },
  { title: "Kreativ höjd", body: "Vi säger nej till slentrian. Manus, bildspråk och tempo byggs för att hooka tummen i flödet, och stanna kvar i minnet." },
  { title: "Fast månadspris", body: "Ni vet exakt vad ni betalar och vad ni får. Inga överraskningsfakturor, ingen tim-debitering på kreativ process. Skala upp, ner eller pausa." },
  { title: "Rytm som passar ert flöde", body: "Månatliga leveranser, paketerade för rätt kanal och format. Ni publicerar utan att tänka, vi håller maskineriet igång." },
  { title: "En projektledare och en faktura", body: "Ni får Norrhavet Groups hela kraft. Hasty för marknadsavdelningen, Fenny för film, Ellary för marknadsföring — samlat i en sömlös process." },
  { title: "Riktigt hög kvalitet", body: "Vi producerar med professionell filmutrustning och lägger stor vikt vid ljussättning, ljud, vinklar och dramaturgi." },
];

const pillarsEn = [
  { title: "Reliable continuous delivery", body: "Every delivery lands. Every time. The same quality in month 12 as in month 1, with a team that already knows your brand inside out." },
  { title: "Creative ambition", body: "We say no to autopilot. Script, visual language and pace are built to stop the thumb in the feed and stay in the mind." },
  { title: "Fixed monthly price", body: "You know exactly what you pay and what you get. No surprise invoices, no hourly billing on creative process. Scale up, down or pause." },
  { title: "A rhythm that fits your flow", body: "Monthly deliveries packaged for the right channel and format. You publish without thinking; we keep the engine running." },
  { title: "One project lead, one invoice", body: "You get the full force of Norrhavet Group. Hasty for the marketing department, Fenny for video, Ellary for marketing — in one seamless process." },
  { title: "Genuinely high quality", body: "We produce with professional film gear and care deeply about lighting, sound, angles and dramaturgy." },
];

export function Pillars() {
  const en = useLocale() === "en";
  const pillars = en ? pillarsEn : pillarsSv;
  return (
    <Section className="bg-surface/40">
      <EyebrowHeading
        eyebrow={en ? "How we work" : "Så jobbar vi"}
        title={
          <>
            {en
              ? "Strategy, planning, production and continuous delivery — in one and the same rhythm."
              : "Strategi, planering, produktion och löpande leveranser — i en och samma rytm."}
          </>
        }
        lede={en
          ? "We're not just a camera and a crew. We're a growth partner that takes over the whole process from first idea to published video — without you having to micro-manage."
          : "Vi är inte bara en kamera och ett team. Vi är en tillväxtpartner som tar över hela processen från första idé till publicerad film, utan att ni behöver detaljstyra."}
      />

      <div className="mt-14 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
        {pillars.map((p, i) => (
          <article key={p.title} className="relative rounded-3xl border border-white/10 bg-surface p-7 transition-colors hover:border-mint/40">
            <div className="mb-4 text-xs font-mono text-muted-foreground">{String(i + 1).padStart(2, "0")}</div>
            <h3 className="text-xl font-semibold leading-tight">{p.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{p.body}</p>
          </article>
        ))}
      </div>

      <Reveal delay={0.2}>
        <div className="mt-12 flex flex-wrap gap-3">
          <Magnetic>
            <Button to={en ? "/en/contact" : "/kontakt"} variant="mint" arrow trackId="contact_us" trackProps={{ location: "pillars" }}>
              {en ? "Contact us" : "Kontakta oss"}
            </Button>
          </Magnetic>
          <Button to={en ? "/en/pricing" : "/priser"} variant="outline">
            {en ? "Pulse pricing" : "Priser för Fenny Pulse"}
          </Button>
        </div>
      </Reveal>
    </Section>
  );
}
